( function( $ ) {
	let $cartForm = $( '.woocommerce-cart-form' );
	$cartForm.find( 'th.product-thumbnail' ).html( 'Image' );

	const updateProductNameColumn = function() {
		let $cartForm = $( '.woocommerce-cart-form' );
		$cartForm.find( 'td.product-price' ).each( function() {
			$( this ).parent().find( '.product-name' ).append( $( this ).html() );
		} );
	};

	updateProductNameColumn();

	$( document.body ).on( 'updated_cart_totals', function() {
		updateProductNameColumn();
	} );
} )( jQuery );